// 创作记录翻译

export const creationRecord = {
    title: '我的创作',
    description: '查看和管理您所有的AI生成创作',
    loading: '正在加载您的创作...',
    all: '全部',
    completed: '已完成',
    processing: '生成中',
    filterAll: '全部',
    filterImages: '图片',
    filterVideos: '视频',
    filterAudio: '音频',
    view: '查看',
    download: '下载',
    delete: '删除',
    reEdit: '重新编辑',
    share: '分享',
    shareToX: '分享到 X',
    shareToFacebook: '分享到 Facebook',
    enterShareText: '输入分享文案',
    useTemplate: '使用模板文案',
    templateShareText: '2025年最强AI内容工具没有之一！{brand} 统一风格 + 批量生成，自媒体人直接升天！速来！',
    credits: '积分',
    images: '图片',
    noPreview: '无预览',
    confirmDelete: '确定要删除这个创作记录吗？',
    recordCard: {
      createdAt: '创建于',
      downloadOriginal: '下载原始文件',
      downloadProcessed: '下载处理后文件',
      viewDetails: '查看详情'
    },
    emptyState: {
      noRecordsFound: '未找到记录',
      noRecordsDescription: '您还没有创建任何内容，或没有符合筛选条件的记录。',
      startCreating: '开始创作'
    },
    creationThumbnail: '创作缩略图',
    noRecordsFound: '未找到记录',
    noRecordsDescription: '您还没有创建任何内容，或没有符合筛选条件的记录。',
    startCreating: '开始创作',
    types: {
      faceSwap: '捏脸',
      logoGeneration: 'Logo生成',
      idPhotoGeneration: '证件照生成',
      professionalPortrait: '专业肖像',
      popArtPortrait: '波普艺术肖像',
      animeStyle: '动漫风格',
      oilPainting: '油画风格',
      watercolor: '水彩风格',
      sketchStyle: '素描风格',
      cyberpunk: '赛博朋克',
      restoredImage: '图像修复',
      TEXT_TO_IMAGE: '文生图',
      IMAGE_TO_IMAGE: '图生图',
      TEXT_TO_VIDEO: '文字转视频',
      IMAGE_TO_VIDEO: '图片转视频',
      REFERENCE_IMAGE_TO_VIDEO: '参考图转视频',
      KEY_IMAGE_TO_VIDEO: '关键帧生成视频',
      TEXT_TO_AUDIO: '文生音频',
      IMAGE_TO_AUDIO: '图生音频',
      LYRICS_GENERATION: '歌词生成'
    }
  };
